var map = {
	"./BOU/instore.png": "cfd9",
	"./DRU/instore.png": "b867",
	"./FNB/instore.png": "7d1c",
	"./HIM/instore.png": "31ef",
	"./SUP/instore.png": "b7f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8846";